import React from 'react'
import { IconButton } from '@st-operations/uikit/src/v2'
import { useDropdown } from '_hooks'

import './styles.scss'

const SettingsToggle = ({ style, label, children }) => {
  const controlsDropdown = useDropdown()

  return (
    <div className="settings-toggle" style={style}>
      <span className="settings-toggle__label">{label}</span>
      <div className="settings-toggle__button-container">
        <IconButton
          classes={{ button: 'settings-toggle__button' }}
          iconProps={{ type: 'outline', icon: 'faders', color: 'currentColor' }}
          onClick={() => controlsDropdown.handleToggle()}
          isActive={controlsDropdown.isOpen}
        />
        <If condition={controlsDropdown.isOpen}>
          <If condition={typeof children !== 'function'}>
            <div className="settings-toggle__controls-container">{children}</div>
          </If>
          <If condition={typeof children === 'function'}>
            {children({ onClose: controlsDropdown.handleClose })}
          </If>
        </If>
      </div>
    </div>
  )
}

export default SettingsToggle
